// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
import React, {useMemo, useCallback} from 'react';
import {
    Route as Lib_route,
    Switch as Lib_switch,
} from 'react-router-dom';
import {wrap_cp_url, get_embedded_data} from '../util.js';
import ErrorPage from '../pages/error.js';

function Route({path, comp, server_props}){
    const Comp = comp;
    const render = useCallback(rp=>
        <Comp {...server_props} {...rp}/>, [Comp, server_props]);
    return <Lib_route exact path={path} render={render}/>;
}

export function Switch({routes, children}){
    const sp = useMemo(()=>get_embedded_data('server_props'), []);
    const render_err = useCallback(rp=><ErrorPage {...sp} {...rp}/>, [sp]);
    return <Lib_switch>
      {routes.map(({path, Comp})=>
          <Route key={path} path={path} comp={Comp} server_props={sp}/>
      )}
      {children}
      <Lib_route key="404" render={render_err}/>
    </Lib_switch>;
}

export const createSetComp = route_list=>(path, Comp)=>{
    const inc_path = wrap_cp_url(path);
    const route = route_list.find(r=>r.path==inc_path);
    if (!route)
        throw new Error(`Invalid route '${inc_path}'`);
    route.Comp = Comp;
};
